export const selectTheme = (state) => state.auth.user.theme;
